// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
//
import TourGuideEditForm from '../tour-guide-new-edit-form';

// ----------------------------------------------------------------------

export default function TourGuideCreateView() {
  const settings = useSettingsContext();

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Create a New Tour Guide"
        links={[
          {
            name: 'Dashboard',
            href: paths.dashboard.root,
          },
          {
            name: 'Tour Guides',
            href: paths.dashboard.tourGuide.root,
          },
          { name: 'New Tour Guide' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <TourGuideEditForm />
    </Container>
  );
}
